import { LoaderFunctionArgs } from 'react-router-dom';

import { assertPresence } from '../../lib/runtime';
import { parseSearchParams } from '../../lib/url';
import { loadCountryOptions } from '../../queries/form-data';
import { loadCatalogSettings, loadCollection, loadCollectionItems, loadCollections } from '../../queries/rewards';
import { createCollectionParamParser } from './utils';

export const loadSettings = () => loadCatalogSettings();
export const loadIndex = () => loadCollections();
export const loadCollectionDetail = async ({ params, request }: LoaderFunctionArgs) => {
	const { id } = params;
	const searchParams = new URL(request.url).searchParams;
	const queryParams = parseSearchParams(searchParams, ...createCollectionParamParser());
	assertPresence(id);
	const [collection] = await Promise.all([loadCollection(id), loadCountryOptions()]);

	return loadCollectionItems(collection.id, queryParams);
};
